

import { mapState, mapStores } from 'pinia';
import { defineComponent } from 'vue';
import { NTooltip, NSwitch, NButton, NButtonGroup } from 'naive-ui'
;
import { Recommandation } from '~/api/models/recommandation.model';
import { useWeatherStore } from '~/store/weather.store';
import ComponentBase from '~/components/component-base';
import { useWidgetStore } from '~/store/widgets.store';
import { useDashboardStore } from '~/store/dashboard.store';
import StationEditionModal from '~/components/modals/station-edition-modal.vue';

export default defineComponent({

    extends: ComponentBase,

    components: {
    NTooltip,
    NButton,
    NButtonGroup,
    NSwitch,
    StationEditionModal
},

    data() {
        return {
            isLoading: false,
        }
    },

    async mounted(): Promise<void> {
        await this.weatherStore.fetchRecommandation(this.$i18n.locale);
    },

    computed: {
        ...mapStores(useWeatherStore, useDashboardStore, useWidgetStore),
        ...mapState(useDashboardStore, ['currentStation', 'city', 'location', 'temperatureExt', 'aqiExt' , 'mode']),
        ...mapState(useWeatherStore, ['aqiTexts']),
        ...mapState(useWidgetStore, ['locked', 'widgets']),

        recommandation(): Recommandation {
            return !!this.aqiTexts && this.aqiTexts.find((r: Recommandation) => {
                return this.aqiExt <= r.max && this.aqiExt >= r.min;
            });
        },

        aqiSentenceShort(): string {
            if(!this.aqiExt) {
                return '';
            }

            const index = this.aqiTexts.indexOf(this.recommandation);
            switch(index){
                case 0:
                    return this.$t('dashboard.header.aqi_very_good');
                case 1:
                    return this.$t('dashboard.header.aqi_good');
                case 2:
                    return this.$t('dashboard.header.aqi_moderate');
                case 3:
                    return this.$t('dashboard.header.aqi_unhealthy');
                case 4:
                    return this.$t('dashboard.header.aqi_very_unhealthy');
                default:
                    return '';

            }
        },

        aqiSentence(): string {
            return this.recommandation ? this.recommandation.text : '';
        },

        tvLink(): string {
            if(!this.currentStation) {
                return '';
            }

            return `https://tv.elichens.com/#/dashboard/${this.currentStation.id}?token=${this.currentStation.pairing_token}`
        },

        currentStationName(): string {
            return this.getStationName(this.currentStation);
        }
    },

    methods: {
        setMode(mode: 'hour' | 'day' | 'week' | 'month') {
           this.$router.replace({ path: this.$route ? this.$route.path : '', query: { ...this.$route.query, mode } });
        },

        goToAdvancedView(): void {
            this.$router.push({path: '/advanced-view',  query: { station: this.$route.query.station }})
        },

        // lockChange(value): void {
        //     this.widgetStore.locked = value;
        // },

        async refresh() {
            try {
                this.isLoading = true;
                await this.dashboardStore.refresh();
            } catch(e) {
                this.error('Coud not refresh page', e);
            } finally {
                this.isLoading = false;
            }
        },

        localizeStation(): void {
            if(!this.$refs.stationEditionModal) {
                return;
            }

            //@ts-ignore
            this.$refs.stationEditionModal?.editStation(this.currentStation);
        }
    }
});

